let subscribers = {};

function subscribe(eventname, callback) {
  if (subscribers[eventname] === undefined) {
    subscribers[eventname] = [];
  }

  subscribers[eventname] = [...subscribers[eventname], callback];

  return function unsubscribe() {
    subscribers[eventname] = subscribers[eventname].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventname, data) {
  if (subscribers[eventname]) {
    const promises = subscribers[eventname]
      .map((callback) => callback(data))
    return Promise.all(promises);
  } else {
    return Promise.resolve()
  }
}
